import React, { useEffect, useState } from "react";
import {
  MenuItem,
  IconButton,
  Box,
  TextField,
  Menu,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function SelectRole({
  label,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  errorFormik,
  helperText,
  error,
  disable,
  sx,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  const roles = [
    { id: 1, type: "Teacher" },
    { id: 2, type: "Admin" },
    { id: 3, type: "SGOD - Section Head" },
    { id: 4, type: "SGOD - Unit Head" },
    { id: 5, type: "SGOD - Chief" },
    { id: 6, type: "Education Program Supervisor" },
    { id: 7, type: "OSDS" },
    { id: 8, type: "ASDS" },
    { id: 9, type: "CID - Chief" },
    { id: 10, type: "Administrative Officer 2" },
    { id: 11, type: "Administrative Officer 4" },
    { id: 12, type: "Administrative Officer 5" },
    { id: 13, type: "Project Development Officer 1" },
    { id: 14, type: "Project Development Officer 2" },
    { id: 15, type: "Education Program Specialist 2" },
    { id: 16, type: "Senior Education Program Specialist" },
    { id: 17, type: "Accountant 3" },
    { id: 18, type: "Chief Education Supervisor" },
    { id: 19, type: "School Head" },
    { id: 20, type: "School Non-Teaching Personnel" },
  ];

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 100);
  }, [value]);

  const lowercaseValue = value ? value?.toLowerCase() : "";

  const [selectedRole, setSelectedRole] = useState(
    roles?.find((role) => role.type.toLowerCase() === lowercaseValue) || null
  );

  useEffect(() => {
    setSelectedRole(
      roles?.find((role) => role.type.toLowerCase() === lowercaseValue) || null
    );
  }, [value]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (newValue) => {
    setAnchorEl(null);
    if (newValue) {
      onChange?.(name, newValue.type.toLowerCase() || "");
      setSelectedRole(newValue);
    }
  };

  const handleClear = () => {
    onChange?.(name, ""); // Clear the value
    setSelectedRole(null);
  };

  return (
    <Box>
      <TextField
        label={
          // eslint-disable-next-line no-nested-ternary
          error
            ? `${label || placeholder} - ${error}`
            : disable
            ? `${label || placeholder} - Not Applicable`
            : label
        }
        placeholder={
          // eslint-disable-next-line no-nested-ternary
          error
            ? `${placeholder} - ${error}`
            : disable
            ? `${placeholder} - Not Applicable`
            : placeholder
        }
        name={name}
        variant="outlined"
        size="small"
        disabled={error || disable}
        value={selectedRole && value ? selectedRole.type : ""}
        onClick={handleClick}
        onBlur={onBlur}
        error={errorFormik}
        helperText={helperText}
        sx={sx}
        InputProps={{
          endAdornment: (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <>
                  {selectedRole && (
                    <IconButton edge="end" onClick={handleClear}>
                      <CloseIcon />
                    </IconButton>
                  )}
                  {!disable && !error && (
                    <IconButton edge="end" onClick={handleClick}>
                      <ArrowDropDownIcon />
                    </IconButton>
                  )}
                </>
              )}
            </>
          ),
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
      >
        {roles.map((role) => (
          <MenuItem
            sx={{ width: "100%" }}
            key={role.id}
            onClick={() => handleClose(role)}
          >
            {role.type}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
